/**
 * Message Type that can be sent to a ChargePoint
 */
export enum RecurrencyKindType {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY'
}
